import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Porte do `.empty` do CSS legado (app/web/css/components.css). O legado tem
 * empty states ricos e específicos por tela (ícone + título + texto + ação
 * opcional) — este componente só dá a casca; o conteúdo (ícone, textos,
 * botão) é responsabilidade de quem usa, tela a tela.
 */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("px-4 py-10 text-center", className)}>
      {icon ? (
        <div className="mx-auto mb-3 flex size-9 items-center justify-center rounded-lg bg-accent text-accent-foreground">
          {icon}
        </div>
      ) : null}
      <h4 className="text-sm font-semibold text-fg">{title}</h4>
      {description ? (
        <p className="mx-auto mt-1.5 mb-3 max-w-[340px] text-[0.8125rem] text-fg-soft">
          {description}
        </p>
      ) : null}
      {action ? <div className="mt-3 flex justify-center">{action}</div> : null}
    </div>
  );
}
